export default import.meta.ROLLDOWN_FILE_URL_EUWvBvNMAolt5mlMSnwB2g